import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";

import { ReactNode } from "react";
import {
  effectiveAccessForPage,
  PageKey,
} from "../utility/pageAccess";

const ProtectedRoute = ({
  children,
  requiredRoles,
  pageKey,
}: {
  children: ReactNode;
  requiredRoles: string[];
  /** When set, non-admin users without this page open get redirected away */
  pageKey?: PageKey;
}) => {
  const { user, actualEnterprise, pageAccess } = useAuth();

  if (!user || !requiredRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (
    pageKey &&
    user.role !== "admin" &&
    effectiveAccessForPage(pageAccess, actualEnterprise?.id, pageKey) === "hidden"
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
